import { render } from "./SpErrorNotFound.vue?vue&type=template&id=615853a7&scoped=true"
import script from "./SpErrorNotFound.vue?vue&type=script&lang=js"
export * from "./SpErrorNotFound.vue?vue&type=script&lang=js"

import "./SpErrorNotFound.vue?vue&type=style&index=0&id=615853a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615853a7"]])

export default __exports__